// extracted by mini-css-extract-plugin
export var addressFields = "_my-0";
export var animationContainer = "_my-1";
export var footer = "_my-2";
export var lineItems = "_my-3";
export var modalContent = "_my-4";
export var orderName = "_my-5";
export var strong = "_my-6";
export var warning = "_my-7";